export function shuffleFisherYates<T>(array: Array<T>): Array<T> {
  let i = array.length
  while (i--) {
    const ri = Math.floor(Math.random() * i)
    ;[array[i], array[ri]] = [array[ri], array[i]]
  }
  return array
}
